module.exports = __webpack_public_path__ + "img/shichang.9f53f875.png";